import { render, staticRenderFns } from "./AccessPermissionsDetail.vue?vue&type=template&id=ef7e06ae&scoped=true"
import script from "./AccessPermissionsDetail.vue?vue&type=script&lang=js"
export * from "./AccessPermissionsDetail.vue?vue&type=script&lang=js"
import style0 from "./AccessPermissionsDetail.vue?vue&type=style&index=0&id=ef7e06ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7e06ae",
  null
  
)

export default component.exports